import type { ReactNode } from "react";
import { useT } from "../i18n";
import { CloseIcon } from "./icons";

/**
 * SheetHeader is the top edge of a bottom sheet: what it is, and an × to close
 * it.
 *
 * The close button used to sit in the footer beside the primary action, where
 * a thumb reaching for Ask or Save could land on it — and where nobody looks
 * for it, since every sheet and dialog on a phone closes from the top corner.
 */
export default function SheetHeader({
  title,
  onClose,
  closeTestID,
  children,
}: {
  title: string;
  onClose: () => void;
  closeTestID: string;
  /** Secondary actions, placed just before the ×. */
  children?: ReactNode;
}) {
  const t = useT();
  return (
    <div className="flex items-center gap-2 border-b border-line py-1.5 ps-4 pe-1.5">
      <h2 className="min-w-0 flex-1 truncate text-sm font-semibold">{title}</h2>
      {children}
      <button
        type="button"
        aria-label={t.common.close}
        data-testid={closeTestID}
        onClick={onClose}
        className="grid size-10 shrink-0 place-items-center rounded-full text-muted transition-colors hover:bg-sunk hover:text-ink"
      >
        <CloseIcon />
      </button>
    </div>
  );
}
